import React from "react";
import { useAuth } from "@/hooks/use-auth";

interface ProtectRoleProps {
  allowedRoles: string[];
  children: React.ReactNode;
}

export function ProtectRole({ allowedRoles, children }: ProtectRoleProps) {
  const { user } = useAuth();

  if (!user || !user.role) {
    return null;
  }

  if (!allowedRoles.includes(user.role)) {
    return null;
  }

  return <>{children}</>;
}
